import styled from 'styled-components'

const Monotype = styled.span`
  font-family: Monaco, 'Courier New', Courier, monospace;
  font-size: 0.9em;
`

export default Monotype
